if (!customElements.get("pdp-steps-slider")) {
  customElements.define(
    "pdp-steps-slider",
    class PdpStepsSlider extends HTMLElement {
      constructor() {
        super();
        this.sliderRef = this.querySelector("[data-slider]");
        this.nextRef = this.querySelector('[data-navigation="next"]') || null;
        this.previousRef = this.querySelector('[data-navigation="prev"]') || null;
        this.paginationRef = this.querySelector("[data-pagination]") || null;
        this.initSlider = this.initSlider.bind(this);
        this.productsToShow = 1.5;
        this.autoPlay = false;
        this.spaceBetween = 8;
      }

      connectedCallback() {
        this.initSlider();
      }

      initSlider() {
        this.swiper = new Swiper(this.sliderRef, {
          // Optional parameters
          loop: false,
          spaceBetween: this.spaceBetween,
          autoplay: this.autoPlay || false,
          slidesPerView: this.productsToShow,

          keyboard: {
            enabled: true,
          },

          // If we need pagination
          pagination: {
            el: this.paginationRef,
            clickable: true,
          },

          // Navigation arrows
          navigation: {
            nextEl: this.nextRef,
            prevEl: this.previousRef,
          },
        });
      }

      disconnectedCallback() {
        this.swiper.destroy();
      }
    }
  );
}
